import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nota-fiscal-dialog',
  templateUrl: './nota-fiscal-dialog.component.html',
  styleUrls: ['./nota-fiscal-dialog.component.scss']
})
export class NotaFiscalDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
